module.exports = __webpack_public_path__ + "b84ad4d51ffc5fe5fe92ba39855b1418.MP3";